import SectionHeading from "@/components/SectionHeading";
import { VimeoLite } from "@/components/VimeoLite";
import { motion } from "framer-motion";

const towers = [
  {
    name: "Single Camera Tower",
    description: "Our compact single camera tower delivers wide-area surveillance from one elevated vantage point — ideal for smaller sites or targeted coverage zones.",
    explainerId: "1020098203",
    explainerPoster: "/single-camera-tower-explainer-poster.webp",
    coverageId: "1022749656",
    coveragePoster: "/single-camera-tower-coverage-poster.webp",
  },
  {
    name: "Double Camera Tower",
    description: "The double camera tower provides expanded coverage with two independent camera positions — perfect for larger sites requiring overlapping fields of view.",
    explainerId: "1019689916",
    explainerPoster: "/double-camera-tower-explainer-poster.webp",
    coverageId: "1022746457",
    coveragePoster: "/double-camera-tower-coverage-poster.webp",
  },
];

export default function CameraTowers({ autoLoopVideos = false }: { autoLoopVideos?: boolean }) {
  return (
    <section className="py-20">
      <div className="container">
        <SectionHeading
          label="Our Camera Towers"
          title="Purpose-Built Camera Tower Solutions"
          description="Choose from single or double camera towers to match your site's coverage requirements."
        />
        <div className="space-y-24">
          {towers.map((tower, i) => (
            <motion.div
              key={tower.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <h3 className="font-display text-2xl md:text-3xl font-bold text-foreground mb-8 text-center">
                {tower.name}
              </h3>
              <p className="text-muted-foreground text-center max-w-2xl mx-auto mb-10 leading-relaxed">
                {tower.description}
              </p>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <div>
                  <p className="text-sm font-semibold text-primary uppercase tracking-wider mb-3">Explainer</p>
                  <div className="relative rounded-xl overflow-hidden shadow-card aspect-video">
                    <VimeoLite vimeoId={tower.explainerId} poster={tower.explainerPoster} alt={`${tower.name} explainer video`} autoplay={autoLoopVideos} loop={autoLoopVideos} />
                  </div>
                </div>
                <div>
                  <p className="text-sm font-semibold text-primary uppercase tracking-wider mb-3">Coverage Example</p>
                  <div className="relative rounded-xl overflow-hidden shadow-card aspect-video">
                    <VimeoLite vimeoId={tower.coverageId} poster={tower.coveragePoster} alt={`${tower.name} coverage demo`} autoplay={autoLoopVideos} loop={autoLoopVideos} />
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
